module.exports = __webpack_public_path__ + "static/media/18ECA50.9f217682.jpg";